import omit from "lodash/omit";
import { ACTION_NAMESPACE, ACTIONS } from "./ActionTypes";
import { persistUserReducer } from "../ReduxUserPersist";
const initialState = {};

const UserDataReducer = (state = initialState, action) => {
  switch (action.type) {
    case ACTIONS.SET_ITEM:
      {
        const {
          key,
          value
        } = action.payload;
        return { ...state,
          [key]: value
        };
      }

    case ACTIONS.CLEAR_ITEM:
      return omit(state, [action.payload.key]);

    case ACTIONS.CLEAR_ALL:
      return initialState;

    default:
      return state;
  }
};

export default persistUserReducer({
  key: ACTION_NAMESPACE
}, UserDataReducer);